import request from '@/utils/request'

/**
 * 查询拼团退单列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryAdminRefundGroupOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.queryAdminRefundGroupOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询店铺列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryShopsByAdmin(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopsByAdmin',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}